/*eslint-disable*/
import store from '@/store';
import { options } from 'less';
import { key } from 'localforage';
const tenantCode = store.getters.currentTenant.tenantCode;
// 表单配置信息
export const collapse = [
    {
        title: '白名单配置信息',
        ref: 'whiteForm',
        formName: 'whiteInfo',
        col: 4,
        labelWidth: '100px',
        visible: true,
        formList: [
            {
                label: '申请编码',
                prop: 'customerWhitelistCode',
                value: 'customerWhitelistCode',
                type: 'custom',
                span: 23,
            },
            {
                label: '相关描述',
                prop: 'whitelistRemark',
                value: 'whitelistRemark',
                // type: 'custom',
                // span: 24,
                sourceType: 'input',
                inputType: 'textarea',
                type: 'input',
                span: 23,
                // maxlength: 1024,
                rows: 10,
                showWordLimit: true,
                rule: [{ required: true, message: '相关描述必填！', trigger: 'change' }],
                disabled: false
            },
            {
                label: '是否白名单',
                prop: 'isWhitelist',
                value: 'isWhitelist',
                optionsKey: 'SYS_YES_NO',
                type: 'custom',
                rule: [
                    { required: true, message: '是否白名单不能为空', trigger: 'change' }
                ],
            },
            {
                label: '附件',
                prop: 'relatedFiles',
                value: 'relatedFiles',
                type: 'custom',
                span: 23,
                rule: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.length) {
                                callback(new Error('相关附件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
            {
                label: '',
                prop: 'customerWhiteList',
                value: 'customerWhiteList',
                type: 'custom',
                labelWidth: 0,
                span: 24,
            },
        ]
    },

];
